import React from 'react'
import Link from 'gatsby-link'
import FontAwesome from 'react-fontawesome'

const Footer = () => (
  <div className="footerwrapper">
      <footer class="container">
        <div className="row">
            <div className="col-md-4">
              <p><FontAwesome name='envelope' className="ficon"/><a href="mailto:>rockydesign@gmail.com">rockydesign@gmail.com</a></p>
            </div>
            <div className="col-md-8 text-right">
              <FontAwesome name='linkedin' className="ficon"/>
              <FontAwesome name='github' className="ficon"/>
            </div>
        </div>
      </footer>
  </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js